(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('promoMessageService', promoMessageService);

    promoMessageService.$inject = ['$http', 'guard'];
    function promoMessageService($http, guard) {
        var service = {
            getPromoMessage: getPromoMessage
        };

        return service;

        //------------------------------------------------------
        function getPromoMessage(productTemplateId) {
            guard.argumentHasValue(productTemplateId, "productTemplateId");

            var requestUrl = "/3dprint/promo-messages/" + productTemplateId;

            return $http.get(requestUrl)
                .then(function (response) {
                    var promoMessage = response.data;
                    return !promoMessage ? null : promoMessage;
                });
        }
    }
})();